"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var ReplaySubject_1 = require("rxjs/ReplaySubject");
var operators_1 = require("rxjs/operators");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var document_manager_client_1 = require("./service/api/document-manager.client");
var document_manager_config_provider_1 = require("./service/api/document-manager-config.provider");
var DocumentManagerService = /** @class */ (function () {
    function DocumentManagerService(currentLanguageProvider, entityDocumentSearchService, documentsManagerConfigProvider, kbService, classifierService) {
        this.currentLanguageProvider = currentLanguageProvider;
        this.entityDocumentSearchService = entityDocumentSearchService;
        this.documentsManagerConfigProvider = documentsManagerConfigProvider;
        this.kbService = kbService;
        this.classifierService = classifierService;
        this.reloadDocuments$ = new ReplaySubject_1.ReplaySubject(1);
    }
    DocumentManagerService.prototype.getCurrentLanguage = function () {
        if (!this.currentLanguageId$) {
            this.currentLanguageId$ = this.currentLanguageProvider.getCurrentLanguage().pipe(operators_1.map(function (language) { return language.getId(); }), operators_1.publishReplay(1), operators_1.refCount());
        }
        return this.currentLanguageId$;
    };
    DocumentManagerService.prototype.getUsers = function (caseCategoryName, caseInstanceId) {
        var _this = this;
        if (!this.users$) {
            this.users$ = this.getDocuments(caseCategoryName, caseInstanceId)
                .pipe(operators_1.switchMap(function (documentsData) {
                var userIds = documentsData['result'].map(function (documentData) { return documentData['docInfo'].userId; });
                return _this._getIdFieldName$('User').pipe(operators_1.switchMap(function (idFieldName) {
                    var filterCriteria = new idm_classifier_service_client_js_1.FilterBuilder().in(idFieldName, userIds).buildJson();
                    return _this.classifierService.loadClassifiersByFilter('User', filterCriteria);
                }));
            }), operators_1.publishReplay(1), operators_1.refCount());
        }
        return this.users$;
    };
    DocumentManagerService.prototype._getIdFieldName$ = function (categoryName) {
        return this.kbService.getIdentityMetaField(categoryName)
            .pipe(operators_1.map(function (metaField) {
            return metaField.getMetaFieldId().getSystemName();
        }), operators_1.publishReplay(1), operators_1.refCount());
    };
    DocumentManagerService.prototype.reloadDocuments = function (pagingOptions, filter) {
        this.reloadDocuments$.next({ pagingOptions: pagingOptions, filter: filter });
    };
    DocumentManagerService.prototype.getDocuments = function (caseCategoryName, caseInstanceId) {
        var _this = this;
        if (!this.documentsData$) {
            this.reloadDocuments(new idm_de_core_frontend_1.PagingOptions(0, 10), null);
            this.documentsData$ = this.reloadDocuments$.pipe(operators_1.switchMap(function (loadData) {
                return _this.documentsManagerConfigProvider.loadDocumentManagerConfig()
                    .pipe(operators_1.take(1), operators_1.switchMap(function (config) {
                    var sortOptions = { field: config.sortingField, direction: config.sortDirection };
                    return _this.entityDocumentSearchService.loadDocumentsByEntityId(caseCategoryName, caseInstanceId, loadData.pagingOptions, loadData.filter, sortOptions);
                }));
            }), operators_1.publishReplay(1), operators_1.refCount());
        }
        return this.documentsData$;
    };
    DocumentManagerService.prototype.getFolderNames = function (caseCategoryName) {
        var _this = this;
        return this.entityDocumentSearchService.loadFolders(caseCategoryName).pipe(operators_1.switchMap(function (folders) {
            return _this.kbService.getMainEntityMetaCategories('de-service')
                .pipe(operators_1.map(function (categoryData) {
                var folderNames = [];
                folders.forEach(function (folder) {
                    categoryData.forEach(function (mainEntity) {
                        if (folder === mainEntity.getSystemName()) {
                            folderNames.push({
                                folder: folder,
                                message: mainEntity.getDisplayNameMultilingual(),
                                count: 0
                            });
                        }
                    });
                });
                return folderNames;
            }));
        }), operators_1.publishReplay(1), operators_1.refCount());
    };
    DocumentManagerService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            document_manager_client_1.DocumentManagerClient,
            document_manager_config_provider_1.DocumentManagerConfigProvider,
            idm_kb_service_client_js_1.KbService,
            idm_classifier_service_client_js_1.ClassifierService])
    ], DocumentManagerService);
    return DocumentManagerService;
}());
exports.DocumentManagerService = DocumentManagerService;
//# sourceMappingURL=document-manager-service.js.map